import { formDataType } from "../AddSite";
import React from "react";
import { Divider } from "primereact/divider";
import { Input } from "../../../../components/Shared/Forms";
import styles from "../add-site.module.css";
import { PhoneInput } from "react-international-phone";

interface ClientProfessionalTeamProps {
  formData: formDataType;
  setFormData: React.Dispatch<React.SetStateAction<formDataType>>;
  handleInputChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
}

export function ClientProfessionalTeam({
  formData,
  setFormData,
  handleInputChange,
}: ClientProfessionalTeamProps) {
  return (
    <div className={"my-4"}>
      <Divider style={{ margin: 0 }} align="center">
        <p>Safety agent</p>
      </Divider>
      <div className={styles["responsive-grid-2"]}>
        <Input
          label={"Safety agent company name"}
          name={"client_safety_agent_company_name"}
          value={formData.client_safety_agent_company_name}
          onChange={handleInputChange}
        />
        <Input
          label={"Safety agent name"}
          name={"client_safety_agent_name"}
          value={formData.client_safety_agent_name}
          onChange={handleInputChange}
        />
      </div>
      <div className={styles["responsive-grid-2"]}>
        <div>
          <label className="block mb-2">Safety agent phone number</label>
          <PhoneInput
            defaultCountry="za"
            value={formData.client_safety_agent_phone}
            name={"client_safety_agent_phone"}
            onChange={e => {
              setFormData({
                ...formData,
                client_safety_agent_phone: e || "",
              });
            }}
            inputStyle={{
              width: "100%",
              height: "50px",
              border: "1px solid #d1d5db",
              borderRadius: "6px",
              padding: "0.75rem",
              fontSize: "1rem",
              lineHeight: "1.5",
              backgroundColor: "#ffffff",
              outline: "none",
              transition: "border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out",
            }}
            countrySelectorStyleProps={{
              buttonStyle: {
                border: "1px solid #d1d5db",
                borderRadius: "6px 0 0 6px",
                backgroundColor: "#ffffff",
                padding: "0.75rem 0.5rem",
                height: "50px",
              },
            }}
            inputClassName="p-inputtext"
          />
        </div>

        <Input
          name={"client_safety_agent_email"}
          label={"Safety agent email address"}
          value={formData.client_safety_agent_email}
          onChange={handleInputChange}
          placeholder={"Example: john.doe@dsf.co.za"}
          type={"email"}
        />
      </div>
      <Divider style={{ margin: 0 }} align="center">
        <p>Architect</p>
      </Divider>
      <div className={styles["responsive-grid-2"]}>
        <Input
          label={"Architect company name"}
          name={"client_architect_company_name"}
          value={formData.client_architect_company_name}
          onChange={handleInputChange}
        />
        <Input
          label={"Architect name"}
          name={"client_architect_name"}
          value={formData.client_architect_name}
          onChange={handleInputChange}
        />
      </div>
      <div className={styles["responsive-grid-2"]}>
        <div>
          <label className="block mb-2">Architect phone number</label>
          <PhoneInput
            defaultCountry="za"
            value={formData.client_architect_phone}
            name={"client_architect_phone"}
            onChange={e => {
              setFormData({
                ...formData,
                client_architect_phone: e || "",
              });
            }}
            inputStyle={{
              width: "100%",
              height: "50px",
              border: "1px solid #d1d5db",
              borderRadius: "6px",
              padding: "0.75rem",
              fontSize: "1rem",
              lineHeight: "1.5",
              backgroundColor: "#ffffff",
              outline: "none",
              transition: "border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out",
            }}
            countrySelectorStyleProps={{
              buttonStyle: {
                border: "1px solid #d1d5db",
                borderRadius: "6px 0 0 6px",
                backgroundColor: "#ffffff",
                padding: "0.75rem 0.5rem",
                height: "50px",
              },
            }}
            inputClassName="p-inputtext"
          />
        </div>

        <Input
          name={"client_architect_email"}
          label={"Architect email address"}
          value={formData.client_architect_email}
          onChange={handleInputChange}
          placeholder={"Example: john.doe@dsf.co.za"}
          type={"email"}
        />
      </div>
      <Divider style={{ margin: 0 }} align="center">
        <p>Structural engineer</p>
      </Divider>
      <div className={styles["responsive-grid-2"]}>
        <Input
          label={"Structural engineer company name"}
          name={"client_structural_engineer_company_name"}
          value={formData.client_structural_engineer_company_name}
          onChange={handleInputChange}
        />
        <Input
          label={"Structural engineer name"}
          name={"client_structural_engineer_name"}
          value={formData.client_structural_engineer_name}
          onChange={handleInputChange}
        />
      </div>
      <div className={styles["responsive-grid-2"]}>
        <div>
          <label className="block mb-2">Structural engineer phone number</label>
          <PhoneInput
            defaultCountry="za"
            value={formData.client_structural_engineer_phone}
            name={"client_structural_engineer_phone"}
            onChange={e => {
              setFormData({
                ...formData,
                client_structural_engineer_phone: e || "",
              });
            }}
            inputStyle={{
              width: "100%",
              height: "50px",
              border: "1px solid #d1d5db",
              borderRadius: "6px",
              padding: "0.75rem",
              fontSize: "1rem",
              lineHeight: "1.5",
              backgroundColor: "#ffffff",
              outline: "none",
              transition: "border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out",
            }}
            countrySelectorStyleProps={{
              buttonStyle: {
                border: "1px solid #d1d5db",
                borderRadius: "6px 0 0 6px",
                backgroundColor: "#ffffff",
                padding: "0.75rem 0.5rem",
                height: "50px",
              },
            }}
            inputClassName="p-inputtext"
          />
        </div>

        <Input
          name={"client_structural_engineer_email"}
          label={"Structural engineer email address"}
          value={formData.client_structural_engineer_email}
          onChange={handleInputChange}
          placeholder={"Example: john.doe@dsf.co.za"}
          type={"email"}
        />
      </div>
    </div>
  );
}
